// extracted by mini-css-extract-plugin
export default {"tag":"styles_tag__3BPBV","selectedTag":"styles_selectedTag__xq8C3"};